import { Switch as MaterialSwitch } from '@mui/material';
import React from 'react';

type Props = {
  value: boolean;
  onChange: (isOn: boolean) => void;
};

function Switch(props: Props) {
  const { value, onChange } = props;

  const _onChange = (
    _event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    onChange(checked);
  };

  return (
    <MaterialSwitch
      checked={value}
      onChange={_onChange}
      value={value}
      color="primary"
    />
  );
}

export default Switch;
